import { idtype } from "querypieces";

export default `
...on pageBuilder_accordionItem_BlockType {
	${idtype}
}
`